import React from 'react';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import {
  ShoppingBag,
  Map,
  ShoppingCart,
  MoreVert
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { MAIN_COLOR_RED } from '../../assets/styles';
import aiLogo from '../../assets/img/ai-logo.png';

const BottomNavigationBar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Map routes to navigation values
  const getCurrentValue = () => {
    const path = location.pathname;
    if (path === '/cart') return 0;
    if (path === '/map') return 1;
    if (path === '/generating-route') return 2;
    if (path === '/lists') return 3;
    if (path === '/more') return 4;
    return 0; // Default to cart
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    switch (newValue) {
      case 0:
        navigate('/cart');
        break;
      case 1:
        navigate('/map');
        break;
      case 2:
        navigate('/generating-route');
        break;
      case 3:
        navigate('/lists'); // Lists - shopping lists page
        break;
      case 4:
        navigate('/more');
        break;
      default:
        navigate('/cart');
    }
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1001, // Higher than drawer to ensure it stays on top
        borderTop: '1px solid #e0e0e0',
        pb: 1,
        margin: 0,
        padding: 0,
        transform: 'translateZ(0)', // Force hardware acceleration
        willChange: 'transform', // Optimize for animations
        backfaceVisibility: 'hidden', // Prevent flickering
        WebkitTransform: 'translateZ(0)', // Safari hardware acceleration
        contain: 'layout style paint', // Isolate from layout changes
      }}
      elevation={3}
    >
      <BottomNavigation
        value={getCurrentValue()}
        onChange={handleChange}
        showLabels
        sx={{
          height: 70,
          '& .MuiBottomNavigationAction-root': {
            color: '#666',
            '&.Mui-selected': {
              color: MAIN_COLOR_RED,
              '& img': {
                filter: 'none',
                opacity: 1,
              },
            },
            '& img': {
              filter: 'opacity(0.6)',
              transition: 'filter 0.2s',
            },
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.75rem',
            opacity: '1 !important',
            display: 'block !important',
            '&.Mui-selected': {
              fontSize: '0.75rem',
            },
          },
        }}
      >
        <BottomNavigationAction
          label="Products"
          icon={<ShoppingBag />}
        />
        <BottomNavigationAction
          label="Map"
          icon={<Map />}
        />
        <BottomNavigationAction
          label=""
          icon={
            <img 
              src={aiLogo} 
              alt="AI Logo" 
              style={{ 
                width: '40px', 
                height: '40px',
                objectFit: 'contain',
                filter: 'none',
                opacity: 1,
              }} 
            />
          }
          sx={{
            '& .MuiBottomNavigationAction-label': {
              display: 'none !important',
            },
            '& img': {
              filter: 'none !important',
              opacity: '1 !important',
            },
          }}
        />
        <BottomNavigationAction
          label="Lists"
          icon={<ShoppingCart />}
        />
        <BottomNavigationAction
          label="More"
          icon={<MoreVert />}
        />
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNavigationBar;
